import { projectBelongsToProduct } from "@/lib/product-facet/facet-work-mapping";
import type { NavItem } from "@/types";
import {
  isWorkUnassignedToProduct,
  type ProductFilter,
} from "@/types/product-facet";

export interface WorkNavSource {
  id?: string;
  name?: string | null;
  productId?: string | null;
  accessLevelId?: string | null;
  updatedDate?: string | null;
  createdDate?: string | null;
}

function sortWorksByRecency(a: WorkNavSource, b: WorkNavSource): number {
  const aDate = a.updatedDate ?? a.createdDate;
  const bDate = b.updatedDate ?? b.createdDate;

  if (!aDate && !bDate) return 0;
  if (!aDate) return 1;
  if (!bDate) return -1;

  return new Date(bDate).getTime() - new Date(aDate).getTime();
}

export function workItemsToProjectNavItems(works: WorkNavSource[]): NavItem[] {
  return [...works].sort(sortWorksByRecency).map((work) => ({
    label: work.name || "Unnamed Work",
    href: `/projects/${work.id}`,
    icon: "project" as const,
    title: work.name || "Work Item",
    queryObj: { view: "app" },
  }));
}

export interface SidebarProjectNavGroups {
  assignedProjectItems: NavItem[];
  unlinkedProjectItems: NavItem[];
}

export function groupSidebarProjectNavItems(
  works: WorkNavSource[],
  productFilter: ProductFilter,
  functionFacetIds: ReadonlySet<string> | readonly string[],
): SidebarProjectNavGroups {
  const facetIdSet =
    functionFacetIds instanceof Set
      ? functionFacetIds
      : new Set(functionFacetIds);

  const unlinkedWorks = works.filter(isWorkUnassignedToProduct);

  let assignedWorks: WorkNavSource[];
  if (typeof productFilter === "object") {
    assignedWorks = works.filter((item) =>
      projectBelongsToProduct(item.productId, facetIdSet),
    );
  } else {
    assignedWorks = works.filter((item) => !isWorkUnassignedToProduct(item));
  }

  return {
    assignedProjectItems: workItemsToProjectNavItems(assignedWorks),
    unlinkedProjectItems: workItemsToProjectNavItems(unlinkedWorks),
  };
}
